import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { editUser, getUserList } from "../../api/api";

const Edituser = ({ setUsers, users }) => {
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    superuser: "",
  });

  useEffect(() => {
    userlist();
  }, []);

  const userlist = async () => {
    try {
      const response = await getUserList();
      if (response) {
        console.log(response);

        setUsers(response.data);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  console.log(users);

  const handleEditClick = (user) => {
    setEditingUser(user.id);
    setFormData({
      id: user.id,
      name: user.username,
      email: user.email,
      password: user.password,
      superuser: user.super_user,
    });
  };

  const edituser = async () => {
    try {
      let response = await editUser(formData);
      if (response) {
        toast.success("User details updated..");
        userlist();
      }
    } catch (e) {
      toast.error(e);
    }
  };

  console.log(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "superuser" ? value : value;
    setFormData({ ...formData, [name]: newValue });
  };

  const handleCancel = () => {
    setEditingUser(null);
  };

  return (
    <div className="p-5 max-w-md w-full ml-10">
      <h2 className="text-2xl font-bold mb-4">User List</h2>
      <ul className="list-none p-0">
        {users.map((user) => (
          <li key={user.id} className="mb-3">
            {editingUser === user.id ? (
              <div className="flex flex-col">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="mb-3 border border-gray-300 rounded-lg px-3 py-2 outline-none"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="mb-3 border border-gray-300 rounded-lg px-3 py-2 outline-none"
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  className="mb-3 border border-gray-300 rounded-lg px-3 py-2 outline-none"
                />
                <label className="text-left ">Super user</label>
                <select
                  name="superuser"
                  value={formData.superuser}
                  onChange={handleChange}
                  className="mb-3 border border-gray-300 rounded-lg px-3 py-2 outline-none"
                >
                  <option value={"1"}>Yes</option>
                  <option value={"0"}>No</option>
                </select>
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      edituser();
                      setEditingUser(null);
                    }}
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="bg-gray-300 px-4 py-2 rounded"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex items-center gap-3 justify-between">
                <span className="text-gray-800">
                  {user.username} ({user.email})
                </span>
                <button
                  onClick={() => handleEditClick(user)}
                  className="bg-yellow-500 text-white px-3 py-1 rounded"
                >
                  Edit
                </button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Edituser;
